// extracted by mini-css-extract-plugin
export default {"changeChartMode":"Plotly_changeChartMode__fE5Bt","chart":"Plotly_chart__1puAG"};